/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%]{\n    background-color: red;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/case-practice.component.css.shim.ngstyle.js.pre-build-optimizer.js